/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_JobInputs */

const en_page_title_job = /** @type {(inputs: Page_Title_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job posting`)
};

const de_page_title_job = /** @type {(inputs: Page_Title_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle`)
};

/**
* | output |
* | --- |
* | "Job posting" |
*
* @param {Page_Title_JobInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const page_title_job = /** @type {((inputs?: Page_Title_JobInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_JobInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_page_title_job(inputs)
	return en_page_title_job(inputs)
});